module.exports = __webpack_public_path__ + "static/media/banana-is-wrong.94f4a520.mp3";